import React from 'react';
import { Indication, INDICATION_TYPES } from 'taboola-ultimate-ui';
import { useSupplyTargetingSliderValidation } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/hooks/useSupplyTargetingSliderValidation';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const SupplyTargetingSliderValidation = () => {
    const shouldShowWarning = useSupplyTargetingSliderValidation();

    if (!shouldShowWarning) {
        return null;
    }

    return (
        <Indication
            type={INDICATION_TYPES.WARNING}
            displayDismissComponent={false}
            message={
                <FormattedMessage
                    id="campaign.editor.targeting.supply.slider.validation"
                    defaultMessage="Using both Supply Targeting and Site Targeting is not recommended and will narrow your campaign's reach."
                />
            }
        />
    );
};
